type InitialField = {
  id?: string;
  label: string;
  defaultValue?: string | number;
};

export const SCAFFOLD_DEFAULT_VALUE = 'Default value';
export const SCAFFOLD_HEADER_LABEL = 'Header label';
export const SCAFFOLD_CENTRAL_LABEL = 'Central label';
export const SCAFFOLD_FIELD_LABEL = 'Label';
/** Header scaffold label of templates saved before the blank-state designs. */
export const LEGACY_HEADER_LABEL = 'Header One';
export const UNEDITED_HEADER_LABELS: string[] = [
  LEGACY_HEADER_LABEL,
  SCAFFOLD_HEADER_LABEL,
];

/** What header one becomes while loyalty balance is enabled. */
export const BALANCE_FIELD = { id: 'balance_one', label: 'Balance label' };

const headerField = {
  label: SCAFFOLD_HEADER_LABEL,
  defaultValue: SCAFFOLD_DEFAULT_VALUE,
};
const centralField = {
  label: SCAFFOLD_CENTRAL_LABEL,
  defaultValue: SCAFFOLD_DEFAULT_VALUE,
};
const detailsField = {
  label: SCAFFOLD_FIELD_LABEL,
  defaultValue: SCAFFOLD_DEFAULT_VALUE,
};

type SectionConfig = {
  initial: Record<string, InitialField>;
  limit: number;
  minRequired: number;
};

export const FIELD_CONFIG: Record<
  'loyalty' | 'generic' | 'eventTicket' | 'transit' | 'stampCard',
  Record<'header' | 'central' | 'details' | 'back', SectionConfig>
> = {
  loyalty: {
    header: { initial: { one: headerField }, limit: 1, minRequired: 1 },
    central: { initial: {}, limit: 0, minRequired: 0 },
    details: {
      initial: { one: detailsField, two: detailsField },
      limit: 4,
      minRequired: 0,
    },
    back: { initial: {}, limit: 5, minRequired: 0 },
  },
  generic: {
    header: { initial: { one: headerField }, limit: 1, minRequired: 0 },
    central: { initial: { one: centralField }, limit: 1, minRequired: 1 },
    details: {
      initial: { one: detailsField, two: detailsField },
      limit: 6,
      minRequired: 0,
    },
    back: { initial: {}, limit: 5, minRequired: 0 },
  },
  eventTicket: {
    header: { initial: { one: headerField }, limit: 1, minRequired: 1 },
    central: { initial: {}, limit: 0, minRequired: 0 },
    details: {
      initial: { one: detailsField, two: detailsField, three: detailsField },
      limit: 6,
      minRequired: 0,
    },
    back: { initial: {}, limit: 5, minRequired: 0 },
  },
  transit: {
    header: { initial: { one: headerField }, limit: 1, minRequired: 0 },
    central: {
      initial: { one: centralField, two: centralField },
      limit: 2,
      minRequired: 2,
    },
    details: {
      initial: { one: detailsField, two: detailsField },
      limit: 6,
      minRequired: 0,
    },
    back: { initial: {}, limit: 5, minRequired: 0 },
  },
  stampCard: {
    header: {
      initial: {
        one: { id: 'stamp_field', label: 'Stamp Label', defaultValue: 0 },
      },
      limit: 1,
      minRequired: 1,
    },
    central: { initial: {}, limit: 0, minRequired: 0 },
    details: {
      initial: { one: detailsField, two: detailsField },
      limit: 4,
      minRequired: 0,
    },
    back: { initial: {}, limit: 5, minRequired: 0 },
  },
};

export const SLOT_LABELS: Record<string, string> = {
  one: '1',
  two: '2',
  three: '3',
  four: '4',
  five: '5',
  six: '6',
};

export const SLOT_ORDER = [
  'one',
  'two',
  'three',
  'four',
  'five',
  'six',
] as const;

export const FRONT_FIELD_SECTIONS = ['header', 'central', 'details'] as const;

export type FrontFieldSectionKey = (typeof FRONT_FIELD_SECTIONS)[number];
